module.exports = __webpack_public_path__ + "6b09963a766d1d50893c35d3545990eb.gif";